import React, { Component, useContext } from 'react';

import IntervalTable, { NoteDurationsTable, NotesTable, TonesTable } from './RydStaticDataTables';
import { GlobalDataContext, GlobalDataProvider } from '../GlobalDataContext';
import { Link } from 'react-router';
import { RydCollapsableCard } from './widgets/RydCollapsableCard';
function SynesthesiaTable() {

    return (<>
        <table>
            <tr>
                <th>Note</th>
                <th>Synesthesia Color</th>
                <th>Scriabin Synesthesia Color</th>
            </tr>
            <tr>
                <td>C</td>
                <td style={{ backgroundColor: 'var(--nsc-c)' }}>C</td>
                <td style={{ backgroundColor: 'var(--nsc-scm-c)' }}>C</td>
            </tr>
            <tr>
                <td>C#</td>
                <td style={{ backgroundColor: 'var(--nsc-csharp)' }}>C#</td>
                <td style={{ backgroundColor: 'var(--nsc-scm-csharp)' }}>C#</td>
            </tr>
            <tr>
                <td>D</td>
                <td style={{ backgroundColor: 'var(--nsc-d)' }}>D</td>
                <td style={{ backgroundColor: 'var(--nsc-scm-d)' }}>D</td>
            </tr>
            <tr>
                <td>D#</td>
                <td style={{ backgroundColor: 'var(--nsc-dsharp)' }}>D#</td>
                <td style={{ backgroundColor: 'var(--nsc-scm-dsharp)' }}>D#</td>
            </tr>
            <tr>
                <td>E</td>
                <td style={{ backgroundColor: 'var(--nsc-e)' }}>E</td>
                <td style={{ backgroundColor: 'var(--nsc-scm-e)' }}>E</td>
            </tr>
            <tr>
                <td>F</td>
                <td style={{ backgroundColor: 'var(--nsc-f)' }}>F</td>
                <td style={{ backgroundColor: 'var(--nsc-scm-f)' }}>F</td>
            </tr>
            <tr>
                <td>F#</td>
                <td style={{ backgroundColor: 'var(--nsc-fsharp)' }}>F#</td>
                <td style={{ backgroundColor: 'var(--nsc-scm-fsharp)' }}>F#</td>
            </tr>
            <tr>
                <td>G</td>
                <td style={{ backgroundColor: 'var(--nsc-g)' }}>G</td>
                <td style={{ backgroundColor: 'var(--nsc-scm-g)' }}>G</td>
            </tr>
            <tr>
                <td>G#</td>
                <td style={{ backgroundColor: 'var(--nsc-gsharp)' }}>G#</td>
                <td style={{ backgroundColor: 'var(--nsc-scm-gsharp)' }}>G#</td>
            </tr>
            <tr>
                <td>A</td>
                <td style={{ backgroundColor: 'var(--nsc-a)' }}>A</td>
                <td style={{ backgroundColor: 'var(--nsc-scm-a)' }}>A</td>
            </tr>
            <tr>
                <td>A#</td>
                <td style={{ backgroundColor: 'var(--nsc-asharp)' }}>A#</td>
                <td style={{ backgroundColor: 'var(--nsc-scm-asharp)' }}>A#</td>
            </tr>
            <tr>
                <td>B</td>
                <td style={{ backgroundColor: 'var(--nsc-b)' }}>B</td>
                <td style={{ backgroundColor: 'var(--nsc-scm-b)' }}>B</td>
            </tr>
        </table></>);
}

function ChordFamiliesTable() {

    const globalData = useContext(GlobalDataContext);
    if (!globalData || globalData.loading) return <div>Loading...</div>;
    const chordFamilies = globalData.data.chordFamilies;
    return (<>
        <table>
            <tr>
                <th>Name</th>
                <th>Pattern</th>
            </tr>
            {chordFamilies.map((f, i) =>
                <tr key={i}>
                    <td>{f.pattern.name}</td>
                    <td>{f.pattern.chromatic_degrees}</td>
                </tr>)}
        </table>
    </>);
}

function ScalesTable() {

    const globalData = useContext(GlobalDataContext);
    if (!globalData || globalData.loading) return <div>Loading...</div>;
    const scales = globalData.data.scalePatterns;

    return (<>
        <table>
            <tr>
                <th>Name</th>
                <th>Scale</th>
            </tr>
            <tbody>
                {scales.map((f, i) =>
                    <tr key={i}>
                        <td>{f.name}</td>
                        <td>{f.intervals.intervals}</td>
                    </tr>)}
            </tbody>
        </table>
    </>);
}

function EurydiceStaticDataDump() {

    const elements = [
        <IntervalTable />,
        <NotesTable />,
        <TonesTable />,
        <NoteDurationsTable />,
        <ChordFamiliesTable />,
        <ScalesTable />,
        <SynesthesiaTable />
    ];

    return (
        <React.StrictMode>
            <ul>
                <li><Link to="/">Dev Home</Link></li>
            </ul>
            <div>
                <h1>Eurydice Component</h1>
                <GlobalDataProvider>
                    {elements.map((el, i) => (
                        <RydCollapsableCard key={i} title={el.type.name} collapsed={true}>
                            {el}
                        </RydCollapsableCard>
                    ))}

                </GlobalDataProvider>
            </div>
        </React.StrictMode>
    );
}

export default EurydiceStaticDataDump;